interface Props {
  chip: string;
  value: string;
  label: string;
  sub?: string;
  ariaLabel: string;
  onClick?: () => void;
}

export function MemberCardHeroStat({ chip, value, label, sub, ariaLabel, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className="relative flex min-w-0 flex-1 flex-col items-start gap-0.5 rounded-xl border-[1.5px] border-navy bg-gold p-3.5 text-left active:scale-[0.98]"
    >
      <div className="text-[9px] font-extrabold uppercase tracking-[0.12em] text-navy/70">
        {label}
      </div>
      <div className="mt-0.5 font-serif text-[34px] font-extrabold leading-none tracking-[-0.02em] text-navy">
        {value}
      </div>
      {sub && (
        <div className="mt-0.5 text-[9px] font-bold uppercase tracking-[0.04em] text-navy/70">
          {sub}
        </div>
      )}
      <div className="absolute right-3 top-3 rounded-[7px] bg-navy px-[7px] py-[3px] text-[9px] font-extrabold tracking-[0.05em] text-gold">
        {chip}
      </div>
    </button>
  );
}
